import { render, staticRenderFns } from "./planDeduction.vue?vue&type=template&id=1adc5ef8"
import script from "./planDeduction.vue?vue&type=script&lang=js"
export * from "./planDeduction.vue?vue&type=script&lang=js"
import style0 from "./planDeduction.vue?vue&type=style&index=0&id=1adc5ef8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports